import React from 'react';
import { Icon, Input, Button } from "semantic-ui-react";
import { Modal, ModalHeader, ModalBody  } from "reactstrap";
import ImageUploader from "react-images-upload";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromRaw,
  convertFromHTML,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import { createBerita } from "../../api";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import LoadingTop from "../../component/LoadingTop";

const AddBerita = (props) => {
  const [title, setTitle] = React.useState("");
  const [editorState, setEditorState] = React.useState(EditorState.createEmpty())
  const [status, setStatus] = React.useState(null);
  const [modal, setModal] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [thumbnail, setThumbnail] = React.useState(null);
  const [loadingBtn, setLoadingBtn] = React.useState(false);

  const changeStatus = (v) => {
    setStatus((prev) => {
      if(prev !== null) {
        if(prev !== v) return prev === 0 ? 1 : 0; 
        if(prev === 1 || prev === 0) return null;
      } else return v;
    })
  }

  const toggle = () => {
    setModal(!modal)
  };

  const handleSubmit = async () => {
    const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setLoadingBtn(true);
    try {
      await createBerita({status, title, content: html, file});
      window.history.back();
    } catch (err) {}
    setLoadingBtn(false);
  }

  const onDropImage = (images) => {
    setFile(images[0]);
    setThumbnail(URL.createObjectURL(images[0]));
    toggle();
  };

  return (
    <>
      <LoadingTop />
      <div className="card border-0 rounded-0">
        <div className="container py-4 px-5">
          <div className="row">
            <div className="col-md-8 d-flex align-items-center mb-md-0 mb-3">
              <Input 
                className="w-100"
                placeholder="Judul Berita"
                onChange={(e) => setTitle(e.target.value)}
              >
                <input />
              </Input>
            </div>
          </div>
        </div> 
      </div>
      <div className="container mt-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card container shadow-sm py-3 border-0">
              <div className="row">
                <div className="col-md-8">
                  <div className="form-group">
                    <label>Gambar Utama</label>
                    <div className="p-5 w-100 bg-light cursor-pointer" onClick={() => setModal(true)} style={{backgroundImage: "url("+thumbnail+")", backgroundSize: 'cover', backgroundPosition: 'center'}}>
                      <div className="p-5 text-center">
                        <span>
                          {!thumbnail &&
                            <>
                            <Icon name="image outline" size="large"/> Image
                            </>
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <Editor
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor"
                      editorState={editorState}
                      onEditorStateChange={(e) => setEditorState(e)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Status</label>
                    <div>
                      <span className="d-flex align-items-center cursor-pointer mb-2" onClick={() => changeStatus(0)}>
                        <input type="radio" value={0} checked={status === 0} onChange={() => changeStatus(0)} />
                        <span className="badge ml-2 badge-secondary">Draft</span>
                      </span>
                      <span className="d-flex align-items-center cursor-pointer" onClick={() => changeStatus(1)}>
                        <input type="radio" value={1} checked={status === 1} onChange={() => changeStatus(1)} />
                        <span className="badge ml-2 badge-success">Publish</span>
                      </span>
                    </div>
                  </div>
                  {/* <p className="mt-4">Terakhir diperbarui 10 Jan 2020 18:23</p> */}
                  <Button color='green' fluid size="lg" className="mb-2" loading={loadingBtn} onClick={handleSubmit}>Simpan</Button>
                  <Button color='light' fluid size="lg" onClick={() => window.history.back()}>Batal</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Pilih Gambar</ModalHeader>
        <ModalBody>
          <ImageUploader
            {...props}
            withIcon={true}
            withPreview={true}
            singleImage={true}
            onChange={onDropImage}
            imgExtension={[".jpg", ".gif", ".png", ".gif", ".jpeg"]}
            maxFileSize={5242880}
          />
        </ModalBody>
      </Modal>
    </>
  )
}

export default AddBerita
